import React from "react";
import Slider from "react-slick";
import Bajaj from "../../../Assets/Images/Insurance/bajaj-big.png"
import generalicentral from "../../../Assets/Images/Insurance/generali-central-big.png"
import maxlife from "../../../Assets/Images/Insurance/max-life-big.png"

export default function InsurancePartner() {
  const partners = [
   
    {
      image:generalicentral,
    }, {
      image:Bajaj,
    }, 
    
    {
      image: maxlife,
    }
  ]; // Placeholder for partner logos/cards

  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 3, // Desktop
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // Tablet
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640, // Mobile
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    appendDots: (dots) => (
      <div>
        <ul className="tw-flex tw-justify-center tw-space-x-2 tw-mt-4">{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-gray-300"></div>
    ),
  };

  return (
    <section id="partner-insurers" className="tw-py-16 tw-bg-white">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6 tw-text-center">
        <h2 className="tw-text-3xl tw-font-bold tw-text-fintoo-blue tw-mb-4">
          We Partner Only with Trusted Names
        </h2>
        <p className="tw-text-lg tw-text-gray-600 tw-mb-12">
          Your family’s security deserves nothing less than the best. That’s why
          we’ve partnered with <b>Generali Central, Max Life, and Bajaj Allianz</b>{" "}
          — leaders in reliability and service.
        </p>

        <Slider {...sliderSettings} className="tw-px-2">
          {partners.map((partner, index) => (
            <div key={index} className="tw-px-2">
              <div className="tw-flex tw-flex-col tw-items-center tw-h-[200px]  tw-w-full tw-rounded">
                <img src={partner.image} alt="" className="tw-border tw-border-gray-200 tw-border-solid tw-rounded-xl" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
